var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stageIntro"},[_c('e-title',{ref:"title"},[_vm._v("niveau "+_vm._s(_vm.level))]),_c('e-number',{staticClass:"stageIntro__countdown",attrs:{"number":_vm.countdown}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }